import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { REPORT, APPRAISER_REPORT_CREATIVE_ID, INSTANT_OFFER } from 'site-modules/shared/constants/appraisal/appraisal';
import { AppraisalReportToggleBtn } from 'site-modules/shared/components/appraisal/appraisal-report-toggle-btn/appraisal-report-toggle-btn';
import { AppraisalReportExtendedDetails } from './appraisal-report-extended-details';

const HIDE_TEXT = 'Hide detailed report';
const SHOW_TEXT = 'See detailed report';

/**
 * AppraisalReportPriceTableExtended component.
 */
export class AppraisalReportStepExtendedPrices extends Component {
  static propTypes = {
    stepId: PropTypes.string,
    totalPrices: PropTypes.shape({
      tradeIn: PropTypes.number,
      privateParty: PropTypes.number,
      dealerRetail: PropTypes.number,
    }).isRequired,
    getVehicleData: PropTypes.func.isRequired,
    changeStep: PropTypes.func.isRequired,
    emailReportStatus: PropTypes.string,
    resetEmailReportStatus: PropTypes.func,
    updateStepsState: PropTypes.func,
    allConditionPricing: PropTypes.shape({
      rough: PropTypes.object,
      average: PropTypes.object,
      clean: PropTypes.object,
      outstanding: PropTypes.object,
    }),
    selectedReportType: PropTypes.string,
    creativeId: PropTypes.string,
    condition: PropTypes.string,
    mileage: PropTypes.string,
    vin: PropTypes.string,
    color: PropTypes.shape({}),
    isMobile: PropTypes.bool,
    zipCode: PropTypes.string,
    showExteriorColor: PropTypes.bool,
    showAddEquipment: PropTypes.bool,
    optionIds: PropTypes.arrayOf(PropTypes.string),
    modsId: PropTypes.string,
  };

  static defaultProps = {
    stepId: REPORT,
    emailReportStatus: '',
    resetEmailReportStatus: noop,
    updateStepsState: noop,
    allConditionPricing: null,
    selectedReportType: '',
    condition: '',
    creativeId: APPRAISER_REPORT_CREATIVE_ID,
    isMobile: false,
    mileage: '',
    color: {},
    vin: '',
    zipCode: '',
    showExteriorColor: false,
    showAddEquipment: false,
    optionIds: [],
    modsId: '',
  };

  state = {
    isDetailedReportOpen: true,
  };

  getDisplayConditions = () => {
    const { stepId } = this.props;

    switch (stepId) {
      case REPORT:
        return {
          showVehicleDetails: false,
          showBarChart: true,
        };
      case INSTANT_OFFER:
        return {
          showVehicleDetails: true,
          showBarChart: true,
        };
      default:
        return {
          showVehicleDetails: false,
          showBarChart: false,
        };
    }
  };

  getReportView = () => {
    const {
      changeStep,
      stepId,
      emailReportStatus,
      resetEmailReportStatus,
      updateStepsState,
      allConditionPricing,
      selectedReportType,
      condition,
      creativeId,
      isMobile,
      getVehicleData,
      mileage,
      color,
      optionIds,
      vin,
      zipCode,
      showExteriorColor,
      showAddEquipment,
      modsId,
    } = this.props;
    const { isDetailedReportOpen } = this.state;
    const { showVehicleDetails, showBarChart } = this.getDisplayConditions();

    return (
      <AppraisalReportExtendedDetails
        changeStep={changeStep}
        stepId={stepId}
        isDetailedReportOpen={isDetailedReportOpen}
        emailReportStatus={emailReportStatus}
        resetEmailReportStatus={resetEmailReportStatus}
        updateStepsState={updateStepsState}
        allConditionPricing={allConditionPricing}
        selectedReportType={selectedReportType}
        condition={condition}
        creativeId={creativeId}
        isMobile={isMobile}
        getVehicleData={getVehicleData}
        mileage={mileage}
        optionIds={optionIds}
        color={color}
        vin={vin}
        showVehicleDetails={showVehicleDetails}
        showBarChart={showBarChart}
        zipCode={zipCode}
        showExteriorColor={showExteriorColor}
        showAddEquipment={showAddEquipment}
        modsId={modsId}
      />
    );
  };

  /**
   * Toggles visibility of price info.
   */
  toggleDetailedReport = () => this.setState(prevState => ({ isDetailedReportOpen: !prevState.isDetailedReportOpen }));

  render() {
    const { isDetailedReportOpen } = this.state;
    return (
      <div className="appraiser-report-step-extended rounded-12 bg-cool-gray-90 py-1 px-0_5 p-md-1 p-xl-1_5">
        <div className="rounded-12 bg-white py-1_5 px-0_5 px-md-1 px-xl-1_5">
          {this.getReportView()}
          <div className="pt-1">
            <AppraisalReportToggleBtn
              onClick={this.toggleDetailedReport}
              show={!isDetailedReportOpen}
              hideText={HIDE_TEXT}
              showText={SHOW_TEXT}
              btnClassNames="text-blue-50"
            />
          </div>
        </div>
      </div>
    );
  }
}
